import React, { FC } from 'react';
import { RadioProps } from 'react-uforms';
import { WithStyle } from '@ch/common/utils';
import { FormRadioStyled, FormRadioInput, FormRadioLabel, FormRadioIcon } from './radio.styled';
import { RadioStyleProps } from './types';

export const FormRadio: FC<RadioStyleProps & RadioProps> & WithStyle = ({
  ref: _ref,
  as: _as,
  children,
  $size,
  $variant,
  ...rest
}) => {
  return (
    <FormRadioStyled>
      <FormRadioInput {...rest} />
      <FormRadioLabel {...{ $size, $variant }}>
        <FormRadioIcon />
        {children}
      </FormRadioLabel>
    </FormRadioStyled>
  );
};

FormRadio.defaultProps = {
  $size: 'md',
  $variant: 'default',
  disabled: false,
  children: 'Enter',
};
